/* global axios */
import ApiClient from './ApiClient';

class ResponzaChannelInstagramAPI extends ApiClient {
  constructor() {
    super('responza_channel_instagrams', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { responza_channel_instagram: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { responza_channel_instagram: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ResponzaChannelInstagramAPI();
